module.exports = __webpack_public_path__ + "img/horizontal_3_6_9016.d2802b5b.png";